export const Marquee = ({ items }) => (
  <div className="marquee relative overflow-hidden border-y border-white/5 py-6 lg:py-8" data-testid="home-marquee">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((dup) => (
        <div key={dup} aria-hidden={dup === 1} className="flex items-center">
          {items.map((it, i) => (
            <span key={i} className="flex items-center">
              <span className={`whitespace-nowrap px-6 font-display text-3xl font-semibold sm:text-4xl lg:text-5xl ${i % 2 ? "text-stroke" : "text-white/90"}`}>
                {it}
              </span>
              <span className="h-2.5 w-2.5 rounded-full bg-cyan-400/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
